export const MAX_TILE_TAGS_SHOWN = 3;

export const ADDITIONAL_TILE_TAG_ID = 'additional-tag';

export interface TileTag {
  id: string;
  name: string;
  color?: string;
}

export const trimTileTags = <T extends TileTag>(
  tags: T[] | null | undefined,
  maxTagsShown = MAX_TILE_TAGS_SHOWN
): T[] => {
  if (!tags?.length) {
    return [];
  }

  const trimmedTags = tags.slice(0, maxTagsShown);

  if (tags.length > maxTagsShown) {
    trimmedTags.push({
      id: ADDITIONAL_TILE_TAG_ID,
      name: `+${tags.length - maxTagsShown}`
    } as T);
  }

  return trimmedTags;
};

export const trimTileTagsByIds = <T extends TileTag>(
  tagIds: string[] | null | undefined,
  allTags: T[],
  maxTagsShown = MAX_TILE_TAGS_SHOWN
): T[] => {
  const tags = (tagIds ?? []).reduce<T[]>((acc, tagId) => {
    const tag = allTags.find(({ id }) => id === tagId);

    return tag ? acc.concat(tag) : acc;
  }, []);

  return trimTileTags(tags, maxTagsShown);
};
